// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__Y7qrH","info":"UpdateTermsInfo_info__3X4Ne"};